import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { getName } from 'country-list';

const styles = StyleSheet.create({
  detailsContainer: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    maxWidth: '60%'
  },
  label: {
    fontSize: 14,
    fontWeight: 'bold',
    wordWrap: 'break-word'
  },
  desc: {
    fontSize: 11,
    wordWrap: 'break-word'
  }
});

const InvoiceCompany = ({ retailerInfo }) => {
  const address = retailerInfo?.main_address;

  return (
    <Fragment>
      <View style={styles.detailsContainer}>
        <Text style={styles.label}>{retailerInfo.name}</Text>
        {address && (
          <>
            {address.address && (<Text style={styles.desc}>{address.address}</Text>)}
            {(address.city ||  address.state) && (
              <Text style={styles.desc}>{address.city}{address.state && `, ${address.state}`}</Text>
            )}
            {address.country_id && (<Text style={styles.desc}>{getName(address.country_id)}</Text>)}
          </>
        )}
      </View>
    </Fragment>
  )
}

export default InvoiceCompany;
